module.exports = __webpack_public_path__ + "media/icons/calendar-icon-8f7fce62.svg";